// extracted by mini-css-extract-plugin
export default {"root":"MobileCalendarSurface_root__V4NCs","list":"MobileCalendarSurface_list__dzib9"};